import script from "./MenuIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuIndex.vue?vue&type=script&setup=true&lang=js"

import "./MenuIndex.vue?vue&type=style&index=0&id=1997e0bc&lang=css"
import "./MenuIndex.vue?vue&type=style&index=1&id=1997e0bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1997e0bc"]])

export default __exports__